
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.357 10l-.227.113L.463 15.947 0 16.178v18.564l.505.217 5.682 2.435 6.188 2.652L50 35.77V15.132l-37.388-5.098-.255-.034zm.976 1.814l35 4.773v17.695l-35 3.978V11.814zM6.667 35.787V14.708l5-2.5V37.93l-5-2.142zm-5-2.143V17.208L5 15.542v19.53l-3.333-1.428z"}}),_c('path',{attrs:{"d":"M3.333 21.693a.833.833 0 00-.833.834v5.833a.833.833 0 001.667 0v-5.833a.833.833 0 00-.834-.834M9.167 21.693a.833.833 0 00-.834.834v6.666a.833.833 0 001.667 0v-6.666a.833.833 0 00-.833-.834M45 31.76l-3.333.277V18.736l3.333.37V31.76zm-5 .417l-3.333.277V18.177l3.333.37v13.63zm-5 .416l-3.333.278V17.62l3.333.37v14.602zm-5 .417l-3.333.277V17.07l3.333.37V33.01zm-5 .417l-3.333.277v-17.19l3.333.37v16.543zm-5 .416l-3.333.278V15.957l3.333.371v17.515zm25.925-16.311l-30-3.334a.833.833 0 00-.925.829v20a.833.833 0 00.833.833.638.638 0 00.07 0l30-2.5a.833.833 0 00.764-.833V18.36a.833.833 0 00-.742-.828z"}})])])
          )
        }
      }
    